import api from "../security/api";

const viewMenuFindByRole = (client, instance, role) => {    
    return api
        .get(`menu/findByRole?client=${client}&instance=${instance}&role=${role}`)
};

const viewMenuGlobal = (client, instance) => {    
    return api
        .get(`menu/findAll?client=${client}&instance=${instance}`)
};

const menuService = {
    viewMenuFindByRole,
    viewMenuGlobal
};


export default menuService;
